import apiUrl from '../../../constants';
import axios from 'axios';
import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import Pagination from './../shared/pagination'

export default {
	name: 'merchant',
	components: {
		Paginate,
		Pagination,
		VueElementLoading,
		DatePicker
	},
	data: function() {
		return {
			// totalRows:0,
			totalPage: 0,
			totalRows:0,
			currentPage: 1,
			pageLimit:10,
		  searchFlag:false,
			gstcheck: 0,
			pancheck: 0,
			clienterr: '',
			validated: false,
			merchantname: '',
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			modalShow: false,
			updatemerchantmodal: false,
			editmerchantmodal: false,
			addmerchantmodal: false,
			merchantaction: '',
			merchantpersonemail: '',
			businesstype: '',
			merchantname: '',
			merchantid: '',
			localclientid: '',
			status: '',
			isLoading: false,
			is_Loading: false,
			resultCount: '',
			model: {
				name: '',
				username: ''
			},
			// initialize form field
			addmerchant: {
				merchantname: "",
				businesstype: "",
				merchantpersonemail: '',
				merchantaddress: '',
				merchantaddress2: '',
				country: '',
				state: '',
				city: '',
				pincode: '',
				merchantpersonname: '',
				merchantpersonmobile: '',
				merchantpersonphone: '',
				merchantregisternum: '',
				merchantpanid: '',
				merchantgstnum: '',
				merchantloginemail: '',
				password: '',
				suppliergstnno: '',
				druglicenseno: '',
				foodlicenseno: '',
				contactdetails: '',
				pannumber: '',
				druglicensenodate: '',
			},
			status: '',
			changestatus: '',
			loginuserid: '',
			newdateobject: '',

			listStateData: [],
			listCityData: [],
			listMerchantData: [],

			listClientData: [],
			// totalPage: 0,
			// pageNo: 0,
			// pageLimit: 5,
			user_type: '',
			client: '',
			clientid: '',
			showSelectClient: false,
			ClientErr: '',
			input: {},
			addClientid : '',
		}
	},
	created: function() {
		// when a page loads,mounted() will be call
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		},
		capitalize: function(value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		}

	},

	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.getStateList();
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.loginuserid = userdetail.userid;
		this.userid=this.loginuserid
		this.user_type = userdetail.utype;
		if (localStorage.getItem("selectedWarehouse")=='undefined')
		{
			this.$alertify.error("Provide Warehouse name");
		}
		if (localStorage.getItem("selectedClient")!='undefined')
		{
			this.currentPage = 1;
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				// console.log("abcd");
				// this.getClientList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				// this.getClientList();
				this.getMerchantData();
				//this.getStateList();
				break;

			case 'warehouse_user':
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {

		validatePan() {
			var txtPANCard = document.getElementById("merchantpanid");
			var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
			if (regex.test(txtPANCard.value.toUpperCase())) {
				this.pancheck = 0;
			} else {
				this.pancheck = 1;
				return false;
			}
		},
		//validate gst
		validateGst() {
			var txtgst = document.getElementById("merchantgstnum");
			var regexx = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
			if (regexx.test(txtgst.value.toUpperCase())) {
				this.gstcheck = 0;
			} else {
				this.gstcheck = 1;
				return false;
			}
		},

		validateformat() {
			var txtPANCard = document.getElementById("merchantpanid");
			var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
			if (regex.test(txtPANCard.value.toUpperCase())) {
				this.pancheck = 0;
				var txtgst = document.getElementById("merchantgstnum");
				var regexx = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
				if (regexx.test(txtgst.value.toUpperCase())) {
					this.gstcheck = 0;
					if (this.merchantaction == 'add') {
						this.saveMerchant()
					} else if (this.merchantaction == 'edit') {
						this.editMerchant()
					}
				} else {
					console.log("Invalid GST No");
					this.gstcheck = 1;
					return false;
				}
			} else {
				this.pancheck = 1;
				console.log("Invalid Pan No");
				return false;
			}
		},

		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageNo = this.totalPage = 0;

		// 	this.input = ({});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listClientData = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// },

		// clientSelected() {
		// 	this.clientid = this.client;
		// 	this.currentPage = 1;
		// 	if (this.clientid) {
		// 		this.getMerchantData();
		// 	}
		// },


		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},

		//open new form(popup)
		addNewMerchant() {
			//to initialize all form field or used for clear the form
			// this.addmerchant = [],
			//this.addmerchant={}
			this.resetaddForm();
			this.merchantaction = 'add',
				this.gstcheck = 0,
				this.pancheck = 0,
				this.addmerchantmodal = true;
			//to clear error messages(validation messages)
			this.$validator.reset();
			this.errors.clear();
		},

		addmodalShow() {
			this.Statusaction = 'add'
			this.addmodalShow = true
		},

		//to close active/inactive modal
		closeaddmodalShow() {
			this.addmodalShow = false
		},

		closeStatusMerchantModal() {
			this.modalShow = false
			this.resetaddForm();
		},

		//to close new form
		closeAddMerchantModal() {
			this.addmerchantmodal = false
		},

		//to close edit form
		closeEditMerchantModal() {
			this.addmerchantmodal = false
		},

		//for active/inactive modal
		changeMerchantStatus() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateMerchantStatus',
					'data': {
						'merchantid': this.merchantid,
						'status': this.status.trim(),
						'clientid': localStorage.getItem("selectedClient"),
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then((response) => {
					if (response.data.msg > 0) {
						this.$alertify.success("Merchant Status update Successfully");
						this.addmerchantmodal = false;
						this.getMerchantData();
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException);
				})
		},

		//to get state list
		getStateList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'stateList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listStateData = result.data
				}, error => {
					console.error(error)
				})
		},

		//depending on state ,get city list
		getCityList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				"statename": this.addmerchant.merchantstate
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'cityList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listCityData = result.data
				}, error => {
					console.error(error)
				})
		},
		getMerchantSerach() {
		this.totalPage = 0;
		this.currentPage = 1;
		this.resultCount = 0;
		this.searchFlag = true;
		this.getMerchantData();
	},
		//to get merchant list
		getMerchantData() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.ClientErr = this.$t('common.clientError');
				this.$alertify.error(this.$t('common.clientError'))
				this.currentPage = this.totalPage = 1;
				this.listGRRejectReportData = [];
				return false;
			}
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				merchantname: this.merchantname.trim(),
				merchantpersonemail: this.merchantpersonemail.trim(),
				businesstype: this.businesstype.trim(),
				userid:this.loginuserid==null? this.userid :this.loginuserid,
			});

			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantMaster',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listMerchantData = result.data.rows;
					this.totalRows=result.data.count
					this.isLoading = false;
					this.totalRows = result.data.count;
					this.setPageCounts(result.data.count);
				}, error => {
					console.error(error);
				})
		},

		// save form fields in mysql database
		saveMerchant() {
			if (this.validate == false) {
				return false;
			}
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			var usertype = 'Merchant';
			var roleid = 29

			if (this.addmerchant.merchantname == undefined || this.addmerchant.businesstype == undefined || this.addmerchant.merchantname == undefined || this.addmerchant.merchantaddress == undefined || this.addmerchant.merchantaddress2 == undefined || this.addmerchant.merchantcity == undefined || this.addmerchant.merchantstate == undefined || this.addmerchant.merchantcountry == undefined || this.addmerchant.merchantpanid == undefined || this.addmerchant.merchantgstnum == undefined || this.addmerchant.merchantpersonname == undefined || this.addmerchant.merchantpersonemail == undefined || this.addmerchant.merchantpersonphone == undefined || this.addmerchant.merchantpersonmobile == undefined) {

				return false;
			} else {
				this.input = ({
					clientid: localStorage.getItem("selectedClient"),
					merchantname: this.addmerchant.merchantname,
					businesstype: this.addmerchant.businesstype,
					merchantname: this.addmerchant.merchantname,
					merchantpassword: this.addmerchant.merchantname,
					merchantaddress: this.addmerchant.merchantaddress,
					merchantaddress2: this.addmerchant.merchantaddress2,
					city: this.addmerchant.merchantcity,
					state: this.addmerchant.merchantstate,
					country: this.addmerchant.merchantcountry,
					merchantpanid: this.addmerchant.merchantpanid,
					merchantgstnum: this.addmerchant.merchantgstnum,
					merchantregisternum: this.addmerchant.merchantregisternum,
					merchantpersonname: this.addmerchant.merchantpersonname,
					merchantpersonemail: this.addmerchant.merchantpersonemail,
					merchantpersonphone: this.addmerchant.merchantpersonphone,
					merchantpersonmobile: this.addmerchant.merchantpersonmobile,
					pincode: this.addmerchant.merchantpincode,
					roleid: roleid,
					druglicenseno: this.addmerchant.druglicenseno,
					foodlicenseno: this.addmerchant.foodlicenseno,
					druglicensenodate: this.newdateobject,
					usertype: usertype,
					merchantloginemail: this.addmerchant.merchantpersonemail,
				})
				this.is_Loading = true
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'SubmitMerchantData',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then((response) => {

						if (response.data.msg == 1) {
							this.is_Loading = false
							this.$alertify.success(usertype + " Created Successfully")
							this.addmerchantmodal = false
							this.resetaddForm();
							this.getMerchantData();
						} else {
							(response.data.msg == 2)
							this.is_Loading = false
							this.$alertify.error(usertype + " already existed")
						}
					})
					.catch((httpException) => {
						this.$alertify.error("Something Went Wrong");
						console.error('exception is:::::::::', httpException)
					})
			}
		},

		//to get target id in edit action
		getMerchantRowData(data) {
			this.clienterr = "";
			this.$validator.reset();
			this.errors.clear();
			this.getCityList();
			this.merchantaction = 'edit';
			this.addmerchantmodal = true;
			this.addmerchant = data;
			this.merchantid = data.merchantid;
			this.addmerchant.merchantpincode = data.pincode;
			this.addmerchant.merchantcountry = data.country;
			this.loginuserid = data.loginuserid;
			this.addmerchant.merchantstate = data.state;
			this.addmerchant.merchantcity = data.city;
			this.addmerchant.merchantaddress2 = data.merchantaddress2;
      this.addmerchant.merchantpersonmobile = data.merchantpersonmobile;
			this.addmerchant.merchantpersonphone = data.merchantpersonphone;
			this.addmerchant.merchantregisternum = data.merchantregisternum;
			this.addmerchant.druglicenseno = data.druglicenseno;
			this.addmerchant.foodlicenseno = data.foodlicenseno;
			this.addmerchant.druglicensenodate = new Date(this.dateFormat1(data.druglicensenodate));
			this.addClientid = data.clientid;
		},

		//update form fields
		editMerchant() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				merchantid: this.merchantid,
				merchantname: this.addmerchant.merchantname,
				businesstype: this.addmerchant.businesstype,
				merchantname: this.addmerchant.merchantname,
				merchantaddress: this.addmerchant.merchantaddress,
				merchantaddress2: this.addmerchant.merchantaddress2,
				city: this.addmerchant.merchantcity,
				state: this.addmerchant.merchantstate,
				country: this.addmerchant.merchantcountry,
				merchantpanid: this.addmerchant.merchantpanid,
				merchantgstnum: this.addmerchant.merchantgstnum,
				merchantregisternum: this.addmerchant.merchantregisternum,
				merchantpersonname: this.addmerchant.merchantpersonname,
				merchantpersonemail: this.addmerchant.merchantpersonemail,
				merchantpersonphone: this.addmerchant.merchantpersonphone,
				merchantpersonmobile: this.addmerchant.merchantpersonmobile,
				loginuserid: this.loginuserid,
				pincode: this.addmerchant.merchantpincode,
				druglicenseno: this.addmerchant.druglicenseno,
				foodlicenseno: this.addmerchant.foodlicenseno,
				druglicensenodate: this.addmerchant.druglicensenodate,
			})
			this.is_Loading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateMerchant',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.msg > 0) {
						this.is_Loading = false
						this.$alertify.success("Merchant Record Updtaed Successfully");
						this.addmerchantmodal = false;
						this.getMerchantData();
					}
				})
				.catch((httpException) => {
					this.$alertify.error("Something Went Wrong");
					console.error('exception is:::::::::', httpException)
				})
		},

		//to get target id in active/inactive modal
		getStatusRowData(data) {
			this.Statusaction = 'add'
			this.modalShow = true
			this.merchantid = data.merchantid
			this.status = data.mstatus
			if (data.mstatus.trim() == 'active') {
				// console.log(this.changestatus);
				this.changestatus = 'De-Activate'
			} else {
				this.changestatus = 'Activate'
			}
			// console.log(this.changestatus);
		},

		//Sets total number of pages
		setPageCounts(total_rows) {
			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.totalPage = 1;
				} else {
					this.totalPage = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.totalPage = 0;
			}
		},

		//Call page number from pagination
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit;
		// 	this.getMerchantData();
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getMerchantData()
		},

		resetForm() {
			this.totalRows=0
				this.searchFlag = false;
				if(this.user_type!='client_user'){
					this.clientid = '';
				}
			this.merchantname = '';
			this.merchantpersonemail = '';
			this.businesstype = '';
			this.client = "";
			this.listMerchantData = [];
			this.pageNo = this.totalPage = 0;
			this.currentPage = 1;
			if (this.clientid && this.user_type == 'client_user') {
				this.currentPage = 1;
				// this.getMerchantData();
			} else {
				this.clientid = '';
			}
		},

		//validate all form fields on onsubmit()
		onSubmit: function(event) {
			if (localStorage.getItem("selectedClient")== "") {
				this.clienterr = this.$t('common.clientError');
				return false;
			}
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
					console.log('form is valid', this.model)
					this.validateformat()
				}
				// this.validated=true;
			//	event.target.reset();
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		resetaddForm() {
			this.addClientid = '';
			this.clienterr = ""
			this.addmerchant.merchantname = ""
			document.getElementById("merchantname").value = ''
			this.addmerchant.businesstype = ""
			document.getElementById("businesstype").value = ''
			this.addmerchant.merchantpersonemail = ''
			document.getElementById("merchantpersonemail").value = ''
			this.addmerchant.merchantaddress = ''
			document.getElementById("merchantaddress").value = ''
			this.addmerchant.merchantaddress2 = ''
			document.getElementById("merchantaddress2").value = ''
			this.addmerchant.merchantcountry = ''
			document.getElementById("country").value = ''
			this.addmerchant.merchantstate = ''
			document.getElementById("state").value = ''
			this.addmerchant.merchantcity = ''
			document.getElementById("city").value = ''
			this.addmerchant.merchantpincode = ''
			document.getElementById("pincode").value = ''
			this.addmerchant.merchantpersonname = ''
			document.getElementById("merchantpersonname").value = ''
			this.addmerchant.merchantpersonmobile = ''
			document.getElementById("mobile").value = ''
			this.addmerchant.merchantpersonphone = ''
			document.getElementById("merchantpersonphone").value = ''
			this.addmerchant.merchantregisternum = ''
			document.getElementById("merchantregisternum").value = ''
			this.addmerchant.merchantpanid = ''
			document.getElementById("merchantpanid").value = ''
			this.addmerchant.merchantgstnum = ''
			document.getElementById("merchantgstnum").value = ''
			// this.addmerchant.merchantloginemail= ''
			//   document.getElementById("businesstype").value=''
			// this.addmerchant.password='',
			// this.addmerchant.suppliergstnno= ''
			//   document.getElementById("businesstype").value=''
			this.addmerchant.druglicenseno = ''
			document.getElementById("druglicenseno").value = ''
			this.addmerchant.foodlicenseno = ''
			document.getElementById("foodlicenseno").value = ''
			// this.addmerchant.contactdetails= ''
			//   document.getElementById("businesstype").value=''
			// this.addmerchant.pannumber= ''
			//   document.getElementById("businesstype").value=''
			//this.addmerchant.druglicensenodate= ''
			this.newdateobject = ''
			//document.getElementById("adddate").value=''
			// }
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/merchant/merchant.component.js